import { DeliveryType } from '../../coaching-base/config/delivery-type.model';
import { DiffItem } from '../../coaching-base/diff-decorator';
import { GoalDiffContext } from '../../coaching-base/diff-decorator/goal-diff-context.model';
import { ObservationDiffContext } from '../../coaching-base/diff-decorator/observation-diff-context.model';
import { EntityType } from '../../coaching-base/general';
import { MetricItem } from '../../coaching-tags/models/metric.coaching.model';

import { GoalDiffContextView } from './goal-diff-context-view.model';
import { ObservationDiffContextView } from './observation-diff-context-view.model';

// TODO revise. deliveryTypes should be the ones for the observation, not the commitment
function observationDiffContextTransformer(
    model: ObservationDiffContext,
    deliveryTypes: DeliveryType[],
): ObservationDiffContextView {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const deliveryType =
        deliveryTypes.find((e) => e.deliveryTypeId === model.deliveryTypeId) ||
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ({} as DeliveryType);
    return { ...model, deliveryTypeName: deliveryType.deliveryTypeName };
}

function goalDiffContextTransformer(
    model: GoalDiffContext,
    metrics: MetricItem[],
): GoalDiffContextView {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const metric =
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        metrics.find((e) => e.id === model.metricId) || ({} as MetricItem);
    return { ...model, metricName: metric.name };
}

export function diffItemsTransformer(
    model: DiffItem[],
    deliveryTypes: DeliveryType[],
    metrics: MetricItem[],
): DiffItem[] {
    const items: DiffItem[] = [];
    model.forEach((e) => {
        if (e.entityTypeId === EntityType.CoachingEvent) {
            items.push({
                ...e,
                context: observationDiffContextTransformer(
                    e.context,
                    deliveryTypes,
                ),
            });
            return;
        }
        if (e.entityTypeId === EntityType.Goal) {
            items.push({
                ...e,
                context: goalDiffContextTransformer(e.context, metrics),
            });
            return;
        }
        items.push(e);
    });
    return items;
}
